import React, { useMemo } from 'react';
import { AddToShoppingCartButton, CartItem, ShoppingCartContext, WSAppContext } from '@weddingspot/ws-core-components';
import { AnalyticsEvent, logEvent } from '@weddingspot/ws-analytics';
import { Venues } from '@weddingspot/ws-api-client';

import { VenueProfileContext } from '../context';

type AddToShoppingCartButtonComponentProps = {
    labelText?: string;
    nonPrimary?: boolean;
};

const AddToShoppingCartButtonComponent: React.FC<AddToShoppingCartButtonComponentProps> = ({ labelText, nonPrimary = true }) => {
    const context = React.useContext(VenueProfileContext);
    const {getSRPViewFromSessionStorage} = React.useContext(WSAppContext);

    const wsVenueProfile = React.useMemo(() => context.wsVenueProfile, []) as Venues.VenueDetails;

    const { items, removeItem, addItem } = React.useContext(ShoppingCartContext);

    const isInCart = useMemo(() => {
        return Boolean(items.find((item: CartItem) => item.id === wsVenueProfile.id));
    }, [wsVenueProfile, items]);

    const addVenue = (e: React.SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();
        const value = {
            id: wsVenueProfile.id,
            name: wsVenueProfile.name,
            location: `${wsVenueProfile.city}, ${wsVenueProfile.state_abbr}`,
            imageUrl: wsVenueProfile.images && wsVenueProfile.images[0].crop_image,
            lastUpdated: new Date().getTime(),
            market: wsVenueProfile.market,
            isDestination: wsVenueProfile.is_destination,
            address: wsVenueProfile.address_1,
            state: wsVenueProfile.state,
            city: wsVenueProfile.city,
            zipCode: wsVenueProfile.zip_code,
            srpView: getSRPViewFromSessionStorage(wsVenueProfile.id),
            contractPackage: wsVenueProfile.contract_package,
        };
        addItem(value);
        logEvent(AnalyticsEvent.EVTNM_VENUE_ADDED_TO_CART, { source: 'Venue profile v3' });
    };
    const removeVenue = (e: React.SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();
        removeItem(wsVenueProfile.id);
        logEvent(AnalyticsEvent.EVTNM_CLICKED_REMOVE_FROM_LIST_CTA, { source: 'Venue profile v3' });
    };
    return (
        <AddToShoppingCartButton
            isInCart={isInCart}
            removeVenue={removeVenue}
            addVenue={addVenue}
            nonPrimary={nonPrimary}
            labelText={labelText}
        />
    );
};

export default AddToShoppingCartButtonComponent;
